<template>
  <div class="cloudaccount-setup-summary">
    <div v-if="loading || cloudregions.length === 0" style="text-align: center; margin-top: 150px;">
      <a-spin  tip="加载中..." />
    </div>
    <div v-else>
        <!--    // part 1: tips-->
        <h3 class="mt-2">云账号配置情况概览</h3>
        <a-alert
          v-if="tips"
          class="m-2"
          :message="cloudaccount.setup.desc"
          :type="tips.type"
          show-icon>
          <template #description>
            <div>{{ tips.desc }}</div>
            <div v-if="tips.solutions">
              <div>您可尝试如下解决方案,或联系平台技术支持</div>
              <ul>
                <li v-for="(v, index) of tips.solutions" :key="index">{{ v }}</li>
              </ul>
            </div>
          </template>
        </a-alert>
        <!--    // part 2: summary details-->
        <div class="mt-4">
          <a-row type="flex">
            <a-col flex="240px">
              <a-statistic title="可用区(已配置/总数)" :value="totalConfiguredRegion">
                <template #suffix>
                  <span> / {{ totalRegion }}</span>
                </template>
              </a-statistic>
            </a-col>
            <a-col flex="240px" v-if="isInSync">
              <a-statistic title="同步中可用区" :value="totalSyncingRegion">
                <template #suffix>
                  <span> / {{ totalRegion }}</span>
                </template>
              </a-statistic>
            </a-col>
            <a-col flex="auto" v-if="isInSync">
              <a-statistic title="同步已耗时" :value="this.syncMinutes">
                <template #suffix>
                  <span> 分钟 </span>
                </template>
              </a-statistic>
            </a-col>
          </a-row>
        </div>
        <div class="mt-4">
          <a-row>
            <a-collapse default-active-key="1">
              <a-collapse-panel v-for="(rs, index) in regiongroups" :key="index" :header="rs[0].setup.desc" expand-icon-position="left">
                <template v-slot:extra>
                    <a-icon type="setting" @click="handleClickSetting()" v-if="rs[0].setup && (rs[0].setup.can_setup || rs[0].setup.status === 'configured')" />
                </template>
                <a-list :grid="{ gutter: 16, column: 3 }" :data-source="rs">
                  <a-list-item slot="renderItem" slot-scope="item">
                    <div>
                      <strong>{{ formatRegionName(item.name) }}</strong>
                      <p style="font-size: 8px;">{{ formatRegionExternalId(item.external_id) }}</p>
                    </div>
                  </a-list-item>
                </a-list>
              </a-collapse-panel>
            </a-collapse>
          </a-row>
        </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment'
import { GET_CLOUDACCOUNT_SETUP_TIPS } from '../../consts'

export default {
  name: 'CloudAccountSetupSummary',
  props: {
    cloudaccount: {
      type: Object,
      required: true,
    },
    cloudregions: {
      type: Array,
      required: true,
      default: () => { return [] },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tips () {
      if (!this.cloudaccount || !this.cloudaccount.setup) {
        return
      }
      return GET_CLOUDACCOUNT_SETUP_TIPS(this.cloudaccount.setup.status)
    },
    syncMinutes () {
      const from = moment(this.cloudaccount.last_sync)
      const to = this.cloudaccount.last_sync_end_at ? moment(this.cloudaccount.last_sync_end_at) : moment()
      return moment.duration(to.diff(from)).minutes()
    },
    totalRegion () {
      return this.cloudregions.length
    },
    totalSyncingRegion () {
      const syncStatus = ['syncing', 'sync_status', 'queued', 'queuing', 'sync_network']
      return this.cloudregions.filter(item => {
        return syncStatus.indexOf(item.setup.status) >= 0
      }).length
    },
    totalConfiguredRegion () {
      return this.cloudregions.filter(item => {
        return item.setup.status === 'configured'
      }).length
    },
    isInSync () {
      return this.totalSyncingRegion > 0
    },
    regiongroups () {
      const r = {}
      this.cloudregions.map(item => {
        if (r.hasOwnProperty(item.setup.status)) {
          r[item.setup.status].push(item)
        } else {
          r[item.setup.status] = [item]
        }
      })
      return Object.values(r).sort()
    },
  },
  methods: {
    handleClickSetting () {
      this.$emit('changeView', { name: 'CloudAccountSetup', data: this.cloudaccount })
    },
    formatRegionName (name) {
      if (!name) return '-'
      const segs = name.split(' ')
      if (segs.length > 1) {
        return segs.slice(1).join(' ')
      }
      return name
    },
    formatRegionExternalId (ext) {
      if (!ext) return '-'
      const segs = ext.split('/')
      if (segs.length > 1) {
        return segs.slice(1).join('/')
      }
      return ext
    },
  },
}
</script>

<style scoped>
.cloudaccount-setup-summary {
  width: inherit;
  overflow: auto;
  padding: 12px;
}
</style>
